import { Component, OnInit, ViewChild } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels, { Context } from 'chartjs-plugin-datalabels';
Chart.register(...registerables);
Chart.register(ChartDataLabels);
@Component({
  selector: 'app-cockpit-report',
  templateUrl: './cockpit-report.component.html',
  styleUrls: ['./cockpit-report.component.scss'],
})
export class CockpitReportComponent implements OnInit {
  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private Config: Config,
    private cookieService: CookieService,
    private AppService: AppService,
    public translate: TranslateService
  ) {
    const browserLang = this.cookieService.get('language');
    translate.use(browserLang.match(/en|jp/) ? browserLang : 'en');
  }
  canvas: any;
  ctx: any;
  @ViewChild('mychart') mychart: any;
  modelValue: any = '';
  project: any = '';
  projectName: any = '';
  userName: any = '';
  cockpitName: any = '';
  currentDate: Date = new Date();
  allDetails: any = '';
  config: any = '';
  projectId: any = '';
  userId: any = '';
  matchedRuninfo: any = '';
  matchedCleanAttri: any = '';
  matchedAttri: any = '';
  matchedEntity: any = '';
  matchedEutinfo: any = '';
  cleanEUTsArray: any = [];
  notCleanEUTsArray: any = [];
  evalEUTsArray: any = [];
  notEvalEUTsArray: any = [];
  evalAttriArray: any = [];
  notEvalAttriArray: any = [];
  cleanAttriArray: any = [];
  notCleanAttriArray: any = [];
  readyEUTsArray: any = [];
  notReadyEUTsArray: any = [];
  readyAttributesArray: any = [];
  notreadyAttributesArray: any = [];
  myTasksCompletedArray: any = [];
  myTasksNotCompletedArray: any = [];
  euts: any;
  attributes: any;
  scenarios: any = [];
  functionalScenarioCount = 0;
  functionalScenarioPostiveCount = 0;
  functionalScenarioNegativeCount = 0;
  nonFunctionalScenarioCount = 0;
  nonFunctionalScenarioPostiveCount = 0;
  nonFunctionalScenarioNegativeCount = 0;
  functionalPostiveArray: any = [];
  functionalNegativeArray: any = [];
  nonfunctionalPostiveArray: any = [];
  nonfunctionalNegativeArray: any = [];
  functionalTotalArray: any = [];
  nonfunctionalTotalArray: any = [];
  myTasksCount = 0;
  myTasksCompletedPercent: any = 0;
  nonFunctionalScenarioTatalCount: any = 0;
  readynessEUTCountArray: any = [];
  readynessAttrCountArray: any = [];
  evaluvationEUTCountArray: any = [];
  evaluvationAttrCountArray: any = [];
  eutTotalCountArray: any = [];

  ngOnInit(): void {
    this.config = this.Config;
    // language = $cookies.getObject("language");
    // $translate.use(language);
    // allDetails = FactoryServServices.getAlldetails();
    // this.allDetails = JSON.parse(window.localStorage.getItem("allDetails"));
    this.allDetails = {
      evaluvatedAttributes: [],
      evaluvatedEntities: [],
      cleanAttributes: [],
      cleanEntities: [],
    };
    this.userName = window.localStorage.getItem('userName');
    this.projectName = window.localStorage.getItem('projectName');
    this.cockpitName = window.localStorage.getItem('cockpitName');
    this.projectId = window.localStorage.getItem('projectID');
    this.userId = window.localStorage.getItem('userID');
    this.ProjectServices.getProject(
      window.localStorage.getItem('projectID')
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.project = response.record;

      } else {
      }
    });
    this.currentDate = new Date();
    setTimeout(() => {
      // console.log("this.project", this.project);
      this.euts = this.project.listOfEUTs;
      this.scenarios = this.project.scenarios;
      this.loadReportModel();
    }, 700);

  };

  loadReportModel() {
    if (this.cockpitName == 'elements') {
      this.generateTasks();
      this.generateCharts();
      this.generateFunctionalEUTCharts();
    } else if (this.cockpitName == 'design') {
      this.generateDesign();
      this.generateReadynessEUTCharts();
    } else if (this.cockpitName == 'evaluation') {
      this.generateEvaluation();
      setTimeout(() => {
        this.generateEvaluationEUTCharts();
      }, 500);
    } else if (this.cockpitName == 'outcomes') {
      this.generateOutcomes();
      setTimeout(() => {
        this.generateEvaluationEUTCharts();
      }, 500);
    }
    this.generateEvalAttributes();
  }
  generateFunctionalEUTCharts() {
    var eutPieChart = new Chart("FuctionalEUTpie", {
      type: 'pie',
      data: {
        labels: ["TF", "UR", "BF", "XX"],
        datasets: [
          {
            data: this.eutTotalCountArray,
            backgroundColor: ['rgb(255, 99, 132)', 'rgb(54, 162, 235)', 'rgb(255, 205, 86)', 'rgb(255, 125, 186)']
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            display: false,
            // formatter: function (value, context: any) {
            //   // return context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            //   return value === 0 ? '' : context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            // },
            // color: 'black',
            // labels: {
            //   title: {
            //     font: {
            //       weight: 'bold'
            //     }
            //   },
            // }
          },

          legend: {
            display: true,
            position: 'bottom',
          },
          title: {
            display: true,
            text: "Entity type distribution",
            font: {
              weight: 'bold'
            }
          }
        }
      },
    });
    // eutPieChart.destroy();
  };
  generateReadynessEUTCharts() {
    var eutreadyPieChart = new Chart("ReadynessEUTpie", {
      type: 'pie',
      data: {
        labels: ["Ready", "Not-ready"],
        datasets: [
          {
            data: this.readynessEUTCountArray,
            backgroundColor: ['rgb(255, 99, 132)', 'rgb(54, 162, 235)']
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            display: false,
            // formatter: function (value, context: any) {
            //   // return context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            //   return value === 0 ? '' : context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            // },
            // color: 'black',
            // labels: {
            //   title: {
            //     font: {
            //       weight: 'bold'
            //     }
            //   },
            // }
          },

          legend: {
            display: true,
            position: 'bottom',
          },
          title: {
            display: true,
            text: "Entity readiness distribution",
            font: {
              weight: 'bold'
            }
          }
        }
      },
    });
    // eutreadyPieChart.destroy();

    var attrPieChart = new Chart("ReadynessAttrpie", {
      type: 'pie',
      data: {
        labels: ["Ready", "Not-ready"],
        datasets: [
          {
            data: this.readynessAttrCountArray,
            backgroundColor: ['rgb(255, 99, 132)', 'rgb(54, 162, 235)']
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            display: false,
            // formatter: function (value, context: any) {
            //   // return context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            //   return value === 0 ? '' : context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            // },
            // color: 'black',
            // labels: {
            //   title: {
            //     font: {
            //       weight: 'bold'
            //     }
            //   },
            // }
          },

          legend: {
            display: true,
            position: 'bottom',
          },
          title: {
            display: true,
            text: "Attribute readiness distribution",
            font: {
              weight: 'bold'
            }
          }
        }
      },
    });
    // attrPieChart.destroy();
  };

  generateEvaluationEUTCharts() {
    var eutevalPieChart = new Chart("EvaluvationEUTpie", {
      type: 'pie',
      data: {
        labels: ["Ready", "Not-ready"],
        datasets: [
          {
            data: this.evaluvationEUTCountArray,
            backgroundColor: ['rgb(255, 99, 132)', 'rgb(54, 162, 235)']
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            display: false,
            // formatter: function (value, context: any) {
            //   // return context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            //   return value === 0 ? '' : context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            // },
            // color: 'black',
            // labels: {
            //   title: {
            //     font: {
            //       weight: 'bold'
            //     }
            //   },
            // }
          },

          legend: {
            display: true,
            position: 'bottom',
          },
          title: {
            display: true,
            text: "Entity evaluvation distribution",
            font: {
              weight: 'bold'
            }
          }
        }
      },
    });
    // eutreadyPieChart.destroy();

    var attrEvaPieChart = new Chart("EvaluvationAttrpie", {
      type: 'pie',
      data: {
        labels: ["Ready", "Not-ready"],
        datasets: [
          {
            data: this.evaluvationAttrCountArray,
            backgroundColor: ['rgb(255, 99, 132)', 'rgb(54, 162, 235)']
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            display: false,
            // formatter: function (value, context: any) {
            //   // return context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            //   return value === 0 ? '' : context.chart.data.labels[context.dataIndex] + "(" + value + ")";
            // },
            // color: 'black',
            // labels: {
            //   title: {
            //     font: {
            //       weight: 'bold'
            //     }
            //   },
            // }
          },

          legend: {
            display: true,
            position: 'bottom',
          },
          title: {
            display: true,
            text: "Attribute evaluvation distribution",
            font: {
              weight: 'bold'
            }
          }
        }
      },
    });
    // attrPieChart.destroy();
  }

  generateCharts() {
    var eutTypes = ["TF", "UR", "BF", "XX"];
    var chartLabels = [];
    this.nonFunctionalScenarioTatalCount = 0;
    for (var j = 0; j < eutTypes.length; j++) {
      this.functionalScenarioCount = 0;
      this.functionalScenarioPostiveCount = 0;
      this.functionalScenarioNegativeCount = 0;
      this.nonFunctionalScenarioCount = 0;
      this.nonFunctionalScenarioPostiveCount = 0;
      this.nonFunctionalScenarioNegativeCount = 0;
      var eutCount = 0;
      for (var k = 0; k < this.euts.length; k++) {
        if (this.euts[k].eType == eutTypes[j]) {
          eutCount++;
        }
      }
      this.eutTotalCountArray.push(eutCount);
      var totalCount = 0;
      for (var i = 0; i < this.scenarios.length; i++) {
        // console.log("this.scenarios", this.scenarios[i]);
        var scenarioeType = this.getEtypebyEid(this.scenarios[i].eID);
        this.matchedEutinfo = this.euts.find(
          (eut: any) => (eut.eID == this.scenarios[i].eID && scenarioeType == eutTypes[j])
        );
        if (this.matchedEutinfo) {
          totalCount++;
          if (
            this.scenarios[i].attribute.symbol == 'Fe' ||
            this.scenarios[i].attribute.symbol == 'Rb' ||
            this.scenarios[i].attribute.symbol == 'Fb'
          ) {
            this.functionalScenarioCount++;
            if (this.scenarios[i].cr == '+') {
              this.functionalScenarioPostiveCount++;
            } else {
              this.functionalScenarioNegativeCount++;
            }
          } else {
            this.nonFunctionalScenarioTatalCount++;
            this.nonFunctionalScenarioCount++;
            if (this.scenarios[i].cr == '+') {
              this.nonFunctionalScenarioPostiveCount++;
            } else {
              this.nonFunctionalScenarioNegativeCount++;
            }
          }
        }
      }
      chartLabels.push(eutTypes[j] + '(' + this.functionalScenarioCount + ')');
      this.functionalTotalArray.push(this.functionalScenarioCount);
      this.nonfunctionalTotalArray.push(this.nonFunctionalScenarioCount);
      this.functionalPostiveArray.push(this.functionalScenarioPostiveCount);
      this.functionalNegativeArray.push(this.functionalScenarioNegativeCount);
      this.nonfunctionalPostiveArray.push(this.nonFunctionalScenarioPostiveCount);
      this.nonfunctionalNegativeArray.push(this.nonFunctionalScenarioNegativeCount);
    }
    // console.log("totalCount", chartLabels);
    // console.log("F Total", this.functionalTotalArray);
    // console.log("nF Total", this.nonfunctionalTotalArray);
    // console.log("F+", this.functionalPostiveArray);
    // console.log("F-", this.functionalNegativeArray);
    // console.log("nF+", this.nonfunctionalPostiveArray);
    // console.log("nF-", this.nonfunctionalNegativeArray);
    // var labelsChart = ["+ve", "+ve", "+ve"];
    var myChart = new Chart("mychartStacked", {
      type: 'bar',
      data: {
        labels: chartLabels,
        datasets: [
          {
            label: '+ve',
            data: this.functionalPostiveArray,
            backgroundColor: '#6FF263',
            stack: 'Stack 0',
          },
          {
            label: '-ve',
            data: this.functionalNegativeArray,
            backgroundColor: '#EB6C6E',
            stack: 'Stack 0',
          },
        ]
      },
      options: {
        //   hover: {
        //     mode: null
        //  },
        indexAxis: 'y',
        scales: {
          x:
          {
            stacked: true,
            grid: {
              drawBorder: false,
              color: function (context) {
                if (context.tick.value == 0) {
                  return '#000000';
                } else {
                  return '#DCDBDB';
                }

              },
            },
            ticks: {
              display: false,
            }
          }

        },
        plugins: {
          datalabels: {
            // formatter: function (value, context: any) {
            //   console.log("index", context.dataIndex, value);
            //   var label = labelsChart[context.dataIndex] + '(' + value + ')';
            //   labelsChart[context.dataIndex] = "-ve";
            //   return label;
            // },
            color: 'black',
            labels: {
              title: {
                font: {
                  weight: 'bold'
                }
              },
            }
          },
          legend: {
            display: false,
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Functional Scenarios distribution',
            font: {
              weight: 'bold'
            }
          }
        }
      },
    });
    // myChart.destroy();
  };

  getEtypebyEid(eID: any) {
    this.matchedEutinfo = this.project.listOfEUTs.find(
      (sec: any) => sec.eID == eID
    );
    return this.matchedEutinfo.eType;
  }

  generateDesign() {
    for (var i = 0; i < this.project.listOfEUTs.length; i++) {
      this.matchedEutinfo = this.project.scenarios.find(
        (sec: any) => sec.eID == this.project.listOfEUTs[i].eID
      );
      if (this.matchedEutinfo) {
        this.readyEUTsArray.push(this.project.listOfEUTs[i]);
      } else {
        this.notReadyEUTsArray.push(this.project.listOfEUTs[i]);
      }
    };
    this.readynessEUTCountArray.push(this.readyEUTsArray.length);
    this.readynessEUTCountArray.push(this.notReadyEUTsArray.length);
    for (var j = 0; j < this.config.listOfAttributesUpdated.length; j++) {
      this.matchedEntity = this.project.scenarios.find(
        (att: any) => att.tID == this.config.listOfAttributesUpdated[j].symbol
      );
      if (this.matchedEntity) {
        this.readyAttributesArray.push(this.config.listOfAttributesUpdated[j]);
      } else {
        this.notreadyAttributesArray.push(this.config.listOfAttributesUpdated[j]);
      }
    };
    this.readynessAttrCountArray.push(this.readyAttributesArray.length);
    this.readynessAttrCountArray.push(this.notreadyAttributesArray.length);
  }

  generateTasks() {
    this.myTasksCount = 0;
    for (var i = 0; i < this.project.tasks.length; i++) {
      if (this.project.tasks[i].assignedto == this.userId) {
        this.myTasksCount++;
        if (this.project.tasks[i].completed == true) {

          if (this.myTasksCompletedArray.length == 0) {
            let obj = {
              "entity_Id": this.project.tasks[i].entity_Id,
              "entity_desc": this.project.tasks[i].entity_desc,
              "mID": this.project.tasks[i].moduleID,
              "descs": [' ' + this.project.tasks[i].task_desc + '  ']
            }
            this.myTasksCompletedArray.push(obj);
          } else {
            var found = false;
            for (var j = 0; j < this.myTasksCompletedArray.length; j++) {
              if (this.myTasksCompletedArray[j].entity_Id == this.project.tasks[i].entity_Id) {
                this.myTasksCompletedArray[j].descs.push(this.project.tasks[i].task_desc);
                found = true;
                // return;
              }
            }
            if (found == false) {
              let obj = {
                "entity_Id": this.project.tasks[i].entity_Id,
                "entity_desc": this.project.tasks[i].entity_desc,
                "mID": this.project.tasks[i].moduleID,
                "descs": [' ' + this.project.tasks[i].task_desc + '  ']
              }
              this.myTasksCompletedArray.push(obj);
            }
          }
        } else {
          if (this.myTasksNotCompletedArray.length == 0) {
            let obj = {
              "entity_Id": this.project.tasks[i].entity_Id,
              "entity_desc": this.project.tasks[i].entity_desc,
              "mID": this.project.tasks[i].moduleID,
              "descs": [' ' + this.project.tasks[i].task_desc + '  ']
            }
            this.myTasksNotCompletedArray.push(obj);
          } else {
            var found = false;
            for (var j = 0; j < this.myTasksNotCompletedArray.length; j++) {
              if (this.myTasksNotCompletedArray[j].entity_Id == this.project.tasks[i].entity_Id) {
                this.myTasksNotCompletedArray[j].descs.push(this.project.tasks[i].task_desc);
                found = true;
                // return;
              }
            }
            if (found == false) {
              let obj = {
                "entity_Id": this.project.tasks[i].entity_Id,
                "entity_desc": this.project.tasks[i].entity_desc,
                "mID": this.project.tasks[i].moduleID,
                "descs": [' ' + this.project.tasks[i].task_desc + '  ']
              }
              this.myTasksNotCompletedArray.push(obj);
            }
          }
        }
      }
    }

    if (this.myTasksCount > 0) {
      this.myTasksCompletedPercent = Math.round((this.myTasksCompletedArray.length / this.myTasksCount) * 100);
    } else {
      this.myTasksCompletedPercent = 0;
    }

  }
  //function to get modulename by moduleID
  getModuleName(eut: any) {
    var foundModule: any = this.project.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }
  generateOutcomes() {
    for (var i = 0; i < this.project.listOfEUTs.length; i++) {
      for (var j = 0; j < this.project.scenarios.length; j++) {
        if (this.project.listOfEUTs[i].eID == this.project.scenarios[j].eID) {
          if (this.project.scenarios[j].outcome == 'F') {
            this.notCleanEUTsArray.push(this.project.listOfEUTs[i]);
            break;
          } else {
            if (j == this.project.scenarios.length - 1) {
              this.cleanEUTsArray.push(this.project.listOfEUTs[i]);
            }
          }
        }
      }
    }

    for (var k = 0; k < this.config.listOfAttributesUpdated.length; k++) {
      for (var l = 0; l < this.project.scenarios.length; l++) {
        if (
          this.config.listOfAttributesUpdated[k].symbol ==
          this.project.scenarios[l].tID
        ) {
          if (this.project.scenarios[l].outcome == 'F') {
            this.notCleanAttriArray.push(this.config.listOfAttributesUpdated[k].name);
          } else {
            if (l == this.project.scenarios.length - 1) {
              this.cleanAttriArray.push(this.config.listOfAttributesUpdated[k].name);
            }
          }
        }
      }
    }
  }
  generateEvaluation() {
    for (var i = 0; i < this.project.listOfEUTs.length; i++) {
      // var evaluvated = false;
      // for (var j = 0; j < this.project.tasks.length; j++) {
      //   if (this.project.listOfEUTs[i].eID == this.project.tasks[j].entity_Id) {
      //     if (this.project.tasks[j].completed == false) {
      //       break;
      //     }
      //   }
      // }
      for (var k = 0; k < this.project.scenarios.length; k++) {
        if (this.project.listOfEUTs[i].eID == this.project.scenarios[k].eID) {
          this.matchedRuninfo = this.project.runInfo.find(
            (p: any) => p.scenID == this.project.scenarios[k].scenID
          );
          if (this.matchedRuninfo) {
            if (this.matchedRuninfo.status != 'N') {
              this.evalEUTsArray.push(this.project.listOfEUTs[i]);
              // evaluvated = false;
              break;
            }
          }
        }
        if (k == this.project.scenarios.length - 1) {
          if (
            this.evalEUTsArray.indexOf(this.project.listOfEUTs[i]) > -1
          ) {
          } else {
            this.notEvalEUTsArray.push(this.project.listOfEUTs[i]);
          }
        }
      }
    };
    this.evaluvationEUTCountArray.push(this.evalEUTsArray.length);
    this.evaluvationEUTCountArray.push(this.notEvalEUTsArray.length);
    // console.log("eval",this.evalEUTsArray);
    // console.log("not-eval",this.notEvalEUTsArray);
    for (var m = 0; m < this.config.listOfAttributesUpdated.length; m++) {
      // var attrEvaluvated = false;
      // for (var n = 0; n < this.project.tasks.length; n++) {
      //   if (this.config.listOfAttributesUpdated[m].name == this.project.tasks[n].attribute) {
      //     if (this.project.tasks[n].completed == false) {
      //       break;
      //     }
      //   }
      // }
      for (var o = 0; o < this.project.scenarios.length; o++) {
        if (
          this.config.listOfAttributesUpdated[m].symbol ==
          this.project.scenarios[o].tID
        ) {
          this.matchedRuninfo = this.project.runInfo.find(
            (p: any) => p.scenID == this.project.scenarios[o].scenID
          );
          if (this.matchedRuninfo) {
            if (this.matchedRuninfo.status == 'Y') {
              // evalAttriArray.push(this.config.listOfAttributesUpdated[m].name);
              // attrEvaluvated = false;
              break;
            }
            // else {
            //   attrEvaluvated = true;
            // }
          }
        }
        if (o == this.project.scenarios.length - 1) {
          if (
            this.evalAttriArray.indexOf(this.config.listOfAttributesUpdated[m].name) >
            -1
          ) {
          } else {
          }
        }
      }
    }
  }

  generateEvalAttributes() {
    // console.log('AllDetails', this.allDetails);
    for (var i = 0; i < this.config.listOfAttributesUpdated.length; i++) {
      this.matchedAttri = this.allDetails.evaluvatedAttributes.find(
        (attr: any) => attr.symbol == this.config.listOfAttributesUpdated[i].symbol
      );
      if (this.matchedAttri) {
        this.evalAttriArray.push(this.config.listOfAttributesUpdated[i]);
      } else {
        this.notEvalAttriArray.push(this.config.listOfAttributesUpdated[i]);
      }
      // console.log("eval Attr", this.evalAttriArray);
      // console.log("not-eval Attr", this.notEvalAttriArray);

      this.matchedCleanAttri = this.allDetails.cleanAttributes.find(
        (attr: any) => attr.symbol == this.config.listOfAttributesUpdated[i].symbol
      );
      if (this.matchedCleanAttri) {
        this.cleanAttriArray.push(this.config.listOfAttributesUpdated[i]);
      } else {
        this.notCleanAttriArray.push(this.config.listOfAttributesUpdated[i]);
      }
    }
    this.evaluvationAttrCountArray.push(this.evalAttriArray.length);
    this.evaluvationAttrCountArray.push(this.notEvalAttriArray.length);
    // console.log("this.evaluvationAttrCountArray",this.evaluvationAttrCountArray);

    for (var j = 0; j < this.project.listOfEUTs.length; j++) {
      this.matchedEntity = this.allDetails.cleanEntities.find(
        (attr: any) => attr.eID == this.project.listOfEUTs[j].eID
      );
      if (this.matchedEntity) {
        this.cleanEUTsArray.push(this.project.listOfEUTs[j]);
      } else {
        this.notCleanEUTsArray.push(this.project.listOfEUTs[j]);
      }
    }
  };



  // function generateEvalScenariosByAttribute() {
  //   this.AttributeEvaluationCount = 0;
  //   this.AttributeEvaluationStatus = 0;
  //   this.evaluvatedAttributes = [];
  //   for (var i = 0; i < this.readyAttributes.length; i++) {
  //     this.clean3 = false;
  //     this.breakScenarios = false;
  //     for (var k = 0; k < this.scenarios.length; k++) {
  //       if (this.readyAttributes[i].symbol == this.scenarios[k].tID) {
  //         if(this.breakScenarios == true){
  //           break;
  //         }
  //         for(var l = 0; l < this.runinfo.length; l++){
  //           if(this.scenarios[k].scenID == this.runinfo[l].scenID){
  //             if (this.runinfo[l].status == 'N') {
  //               this.breakScenarios = true;
  //               break;
  //             } else {
  //               this.clean3 = true;
  //             }
  //           }
  //         }
  //       }
  //       if (this.clean3 == true) {
  //         if (k == this.scenarios.length - 1) {
  //           this.evaluvatedAttributes.push(this.readyAttributes[i]);
  //         }
  //       }
  //     }

  //   }
  //   // console.log("1", this.scenarioAttriCount);
  //   // console.log("2", this.AttributeEvaluationCount);
  //   // console.log("this.evaluvatedAttributes",this.evaluvatedAttributes);

  // }
  // }
}
